import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error(
        "[Finance 101] Missing Supabase env vars. " +
        "Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your build environment."
    );
}

export const supabase = createClient(supabaseUrl ?? "https://placeholder.supabase.co", supabaseAnonKey ?? "placeholder", {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
    },
});

let accessTokenInMemory: string | null = null;
export const setAccessToken = (token: string | null) => { accessTokenInMemory = token; };
export const getAccessToken = () => accessTokenInMemory;
